import React from "react";
import { FiHome } from "react-icons/fi";

const TOP_NAV_CATEGORIES = [
    {
        label: "Technical insights",
        href: "/shop/category/tips_vip",
        activePrefixes: ["/next/tech/", "/community/technical_insights"],
        line: "bg-sky-400",
    },
    {
        label: "Digital suite",
        href: "/ai/utility/home_ai",
        activePrefixes: ["/next/orders_once/", "/next/shop/ai", "/shop/ai"],
        line: "bg-violet-400",
    },
    {
        label: "Engineering notes",
        href: "/ai/utility/home_notes",
        activePrefixes: ["/next/docs", "/community/docs"],
        line: "bg-pink-400",
    },
];

export default function TopNavCategories() {
    const currentPath = typeof window !== "undefined"
        ? window.location.pathname.replace(/\/+$/, "") || "/"
        : "";

    return (
        <div
            aria-label="Top navigation categories"
            className="flex min-w-0 flex-1 items-center gap-4 lg:flex-none lg:shrink-0"
        >
            <FiHome aria-hidden="true" className="relative top-px h-5 w-5 shrink-0 text-slate-900" />
            <div className="min-w-0 flex-1 overflow-x-auto overflow-y-hidden lg:flex-none lg:shrink-0">
                <div className="flex min-w-max items-center gap-7 whitespace-nowrap px-0.5 md:gap-9">
                    {TOP_NAV_CATEGORIES.map((category, index) => {
                        const isActive = currentPath
                            ? currentPath === category.href ||
                              currentPath.startsWith(`${category.href}/`) ||
                              category.activePrefixes.some((prefix) => currentPath.startsWith(prefix))
                            : index === 0;

                        return (
                            <a
                                key={category.label}
                                href={category.href}
                                aria-current={isActive ? "page" : undefined}
                                className={`group relative shrink-0 select-none pb-1 pt-2 text-[11px] font-semibold uppercase leading-none tracking-[0.035em] no-underline md:pb-1 md:pt-2 md:text-xs ${isActive ? "text-slate-900" : "text-slate-600"}`}
                            >
                                <span className="relative -top-[2px]">{category.label}</span>
                                {isActive ? (
                                    <span className={`absolute bottom-px left-0 right-0 h-0.5 rounded-full ${category.line}`} />
                                ) : null}
                            </a>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
